import React from 'react';
import { PropTypes } from 'prop-types';
import './AccountDropdownItem.scss'
import HrbTranslate from "../../language/HrbTranslate";
import ClickableDiv from "../../button/ClickableDiv";

const AccountDropdownItem = (props) => (
    <ClickableDiv className="account-dropdown-item" onClick={props.onClick}>
      <i className={"la " + props.imageKey}/>
      <HrbTranslate text={props.label}/>
    </ClickableDiv>
);

AccountDropdownItem.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string
};

export default AccountDropdownItem;